import React from 'react'
import { finq } from '../data/company'
import './PlatformCard.css'

const PlatformCard = () => {
  return (
    <div className="platform-card">
      <div className="platform-card__copy">
        <span className="platform-card__badge">Our platform</span>
        <h2 className="platform-card__title">{finq.name}</h2>
        <p className="platform-card__tagline">{finq.tagline}</p>
        <p className="platform-card__desc">{finq.description}</p>
        <ul className="platform-card__list">
          {finq.highlights.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        <a
          href={finq.url}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary platform-card__cta"
        >
          Visit FinQ
        </a>
      </div>

      <div className="platform-card__visual">
        <figure className="alert-shot">
          <img
            src="/finq-alert.jpg"
            alt="Example FinQ India WhatsApp alert for APOLLO with a contract summary and PDF details link"
            className="alert-shot__img"
            width="484"
            height="900"
            loading="lazy"
          />
        </figure>
        <p className="platform-card__caption">Real FinQ WhatsApp alert</p>
      </div>
    </div>
  )
}

export default PlatformCard
